import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils/utils'

// SEOTags component for injecting SEO meta tags to head
const SEOTags = (props) => {
    const [image, setImage] = useState('')

    const siteDescription = "Club illico vous offre un accès illimité à une foule de productions originales, de séries exclusives, de documentaires et de films en français."
    const jsonLD = props.jsonLD || {}
    const title = jsonLD.title || ''
    const name = jsonLD.name || ''
    const abstract = (jsonLD.abstract || siteDescription).substring(0, 160);
    const subtitleLanguage = jsonLD.subtitleLanguage || ''
    const imagesArr = jsonLD.imagesArr || []
    const location = window.location.href.split(/[?#]/)[0]
    const url = jsonLD.url || location
    const appName = process.env.REACT_APP_TITLE || ''
    const titleTagTitle = (name && appName) ? `${name} - ${appName}` : appName
    
    /**
     * It: Finds the closest matching image by resolution and sets in a state.
     */
    useEffect(() => {
        const image = utils.getCloserMatchImage(1280, 720, imagesArr) || {}
        setImage(image.url || '')
    }, [imagesArr])

    return (
        <Helmet>
            {/* {titleTagTitle && */}
            <title>{titleTagTitle}</title>
            {/* } */}
            {/* {titleTagTitle && */}
            <meta property="og:title" content={title} />
            {/* } */}
            {/* {subtitleLanguage && */}
            <meta property="og:locale" content={subtitleLanguage} />
            {/* } */}
            {/* {abstract && */}
            <meta name="description" content={abstract} />
            {/* } */}
            {/* {abstract && */}
            <meta property="og:description" content={abstract} />
            {/* } */}
            {/* {url && */}
            <meta property="og:url" content={url} />
            {/* } */}
            {/* {image && */}
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1280" />
            <meta property="og:image:height" content="720" />
            {/* } */}
            {/* {image && */}
            <meta property="og:image:secure_url" content={image} />
            <meta content="summary_large_image" name="twitter:card" />
            {/* } */}
            {/* {abstract && */}
            <meta content={abstract} name="twitter:description" />
            {/* } */}
            {/* {name && */}
            <meta content={title} name="twitter:title" />
            {/* } */}
            {/* {image && */}
            <meta content={image} name="twitter:image" />
            {/* } */}
            {/* {url && */}
            <link href={url} rel="canonical" />
            {/* } */}
            {/* {alternate && */}
            <link rel="alternate" hreflang="fr-ca"/>
            {/* } */}
            {/* {Object.keys(jsonLD).length > 0 && */}
            <script type="application/ld+json" id="json_seo">{JSON.stringify(jsonLD)}</script>
            {/* } */}

        </Helmet>
    )
}

export default SEOTags